import React from 'react';
import { Configure } from 'react-instantsearch';
const SearchConfigure = props => /*#__PURE__*/React.createElement(Configure, props);
export default SearchConfigure;